import { useEffect, useState } from "react";
import axios from "../../MyAxios";
import Layout from "../../Layout";
import Title from "../../components/Title";
import useLoggedIn from "../../hooks/useLoggedIn";
import { GET_USER_POSTS } from "../../constants/api";
import Post from "@components/Post";
import { IconButton, Typography } from "@mui/material";
import ShowMore from "@components/ShowMore";
import { MoreVert } from "@mui/icons-material";
import GroupModal from "@components/GroupModal";
import { useNavigate } from "react-router-dom";

const StreamManagement = () => {
  useLoggedIn();

  const navigate = useNavigate();

  const [posts, setPosts] = useState([]);
  const [deletedId, setDeletedId] = useState();
  const [totalPages, setTotalPages] = useState();
  const [page, setPage] = useState(1);
  const [openPageOptions, setOpenPageOptions] = useState(false);
  const [voteStatuses, setVoteStatuses] = useState({});
  useEffect(() => {
    if (!posts || posts.length === 0) return;

    const ids = posts
      .map((p) => {
        const isEvent =
          p.startTime ||
          p.endTime ||
          p.eventType ||
          String(p.id).startsWith("event-");

        return isEvent
          ? (String(p.id).startsWith("event-") ? p.id : `event-${p.id}`)
          : p.id;
      })
      .filter(Boolean);

    if (ids.length === 0) return;


    axios
      .post("/post/vote-status-bulk", {
        ids,
      })
      .then((res) => {
        setVoteStatuses((prev) => ({
          ...prev,
          ...res.data,
        }));
      })
      .catch((err) => {
        console.error("Failed to fetch bulk vote status", err);
      });

  }, [posts]);


  const removePost = (id) => {
    setPosts(posts.filter((post) => post.id !== id));
  };
  const getPosts = async () => {
    try {
      const res = await axios.get(`${GET_USER_POSTS}/${page}`);
      setPosts((prevPosts) => [...prevPosts, ...res.data.posts]);
      setTotalPages(res.data.totalPages);
    } catch (error) { }
  };

  useEffect(() => {
    getPosts();
  }, [deletedId, page]);

  return (
    <Layout>
      <Title back={"/"}>
        <span>My Content</span>
        <span className="absolute right-0">
          <IconButton
            onClick={() => setOpenPageOptions(true)}
          >
            <MoreVert
              sx={{ alignSelf: "center" }}
              fontSize="medium"
              className="cursor-pointer"
            />
          </IconButton>
        </span>
      </Title>

      <GroupModal
        open={openPageOptions}
        setOpen={setOpenPageOptions}
        options={[
          {
            id: 1,
            name: "Topics Filter",
            action: () => navigate(`/profile/tag-management`),
          },
          {
            id: 2,
            name: "Saved",
            action: () => navigate(`/save`),
          },
          {
            id: 3,
            name: "Blocked",
            action: () => navigate(`/blocked`),
          },
        ]}
      />

      {(!posts || posts.length == 0) && <div className="my-10 text-center italic">No Posts To Show</div>}
      {posts?.map((item, key) => (
        <div key={key}>
          <Post
            post={item}
            setDeletedId={setDeletedId}
            comment={false}
            removePost={() => removePost(item.id)}
            voteStatus={
              voteStatuses[
              item?.startTime || item?.eventType || String(item.id).startsWith("event-")
                ? `event-${item.id.replace("event-", "")}`
                : item.id
              ]
            }
          />
        </div>
      ))}
      {page < totalPages && (
        <div
          onClick={() => setPage(page + 1)}
          className="cursor-pointer my-2 text-center mx-4"
        >
          <ShowMore>Show More</ShowMore>
        </div>
      )}
    </Layout>
  );
};

export default StreamManagement;
